<template>
  <div class="tabs_content r-tabs-panel r-tabs-state-active" id="tab-2" style="display: block;">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"
    />
    <section>

     <div class="status">
        <h2 v-translate>Skupiny kanálů</h2>
        <a
            v-if="isEditable"
            :title="$gettext('Přidat skupinu kanálů')"
            :class="['add', 'add_expand', { open: newChannelGroupOpen }]"
            @click.prevent="toggleNewChannelGroup()"
            v-translate>Přidat skupinu kanálů</a>
      </div>
      <div :class="['filter', 'expand_content', { open: newChannelGroupOpen }]">
        <div class="field_left">
          <text-input
              id="channel-group-name-add"
              v-model="newChannelGroup.name"
              :required="true"
              ref="newchannelgroupnameref"
          >
            <translate class="translate">Název skupiny</translate>
          </text-input>
        </div>
        <div class="field_right">
          <div class="field">
            <input
                type="submit"
                class="btn"
                :value="'Přidat' | translate"
                @click.prevent.stop="addNewChannelGroup"
            />
          </div>
        </div>
      </div>

      <div class="table_overflow" id="contentBox" data-table-id="advertising-providers-channel-groups">
        <table class="vypis vypis_detail">
          <thead>
          <tr>
            <th class="no_padding drag_drop" />
            <th class="no_padding checkbox" />
            <sorting-table-title
                v-for="title in tableTitles"
                :key="title.key"
                :column="title.column"
                :sort="getActiveSort(title.column)"
                @changeSorting="changeSorting"
            >{{ title.name }}</sorting-table-title>
            <th class="no_padding edit" />
          </tr>
          </thead>
          <tbody>
            <advertising-provider-channel-group-row
                v-for="channelGroup in channelGroups"
                :entity="channelGroup"
                :key="channelGroup.id"
                :selected-entities="selectedEntities"
                :ref="'channel-group-row-ref-'+channelGroup.id"
                @deleteChannelGroup="deleteChannelGroup"
            />

            <tr v-if="channelGroups.length === 0">
              <td colspan="6">{{ $gettext('Nebyly nalezeny žádné skupiny kanálů.') }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <local-list-action-line
          :entities="channelGroups"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          table-id="advertising-providers-channel-groups"
          @select-all="toggleSelectAll"
          @run-multiple-action="executeMultipleAction"
      />

    </section>

  </div>
</template>

<script>
import AdvertisingProviderChannelGroupRow from "./ChannelGroupRow.vue"
import SortingTableTitle from "../../../common/SortingTableTitle";
import Popup from "@/components/common/Popup"
import localTable from "../../../mixins/local-table";
import popup from "@/components/mixins/popup"

export default {
  name: 'AdvertisingProviderChannelGroups',
  components: { AdvertisingProviderChannelGroupRow, SortingTableTitle, Popup },
  mixins: [localTable, popup],
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  created(AdvertisingProviderChannelGroupService) {
    this.channelGroupService = AdvertisingProviderChannelGroupService;

    this._initChannelGroupsList();
  },
  data() {
    return {
      channelGroups: [],
      sort: null,
      newChannelGroup: {},
      newChannelGroupOpen: false,
    }
  },
  computed: {
    tableTitles() {
      return [
        {key: 1, name: this.$gettext('Název'), column: 'sName'},
        {key: 2, name: this.$gettext('Kanály')},
      ];
    },
    csvHeaders(){
      let headers = this.getCsvHeaderFromSortingTableTitle(this.tableTitles)
      headers.channels.callback = (entity) => { return entity.channels.map(channel => channel.name).join(', '); };

      return headers;
    },
    entities() {
      return this.channelGroups;
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
        {value: 'delete-multi', text: this.$gettext('Smazat')}
      ];
    },
  },
  methods: {
    _initChannelGroupsList() {
      this.setLoadingMessage();
      this.isLoaded = false;

      return this.channelGroupService.getEntitiesByProviderId(this.entity.id, { sort: this.sort })
          .then((response) => {
            this.emptyMessage();
            this.channelGroups = response.advertisingProviderChannelGroups;
          });
    },
    toggleNewChannelGroup() {
      this.newChannelGroupOpen = !this.newChannelGroupOpen
    },
    addNewChannelGroup() {
      let params = {
        name: this.newChannelGroup.name,
        id_advertising_provider: this.entity.id,
      }
      this.channelGroupService.createEntity(params)
          .then((data) => {
            this.$router.push({name: 'advertisingProviderChannelGroupDetail', params: { id: data.id }})
          })
    },
    executeMultipleAction(action, activeKey) {
      let actionIds = this.selectedEntities.join();
      switch (action) {
        case 'delete-multi':
          this.deleteChannelGroup(actionIds, true, 'delete-multi');
          break;
        default:
          this.runMultipleAction(action, activeKey);
      }
    },
    executePopupAction(value) {
      if (value === true) {
        if (this.getPopupAction === 'delete') {
          this.$emit('deleteProvider');
        }
        if (this.getPopupAction === 'delete-channel-group') {
          this.deleteChannelGroup(this.getPopupId, false);
        }
      }
      this.hidePopup();
    },
    deleteChannelGroup(id, showPopup = true, popupType = 'delete') {
      if (showPopup) {
        this.showPopup(id, popupType, 'delete-channel-group')
      } else {
        this.channelGroupService.deleteEntity(id)
            .then(() => {
              this._initChannelGroupsList()
            })
            .catch(function (error) {
              this.setErrorMessage(this._processDetailErrorMessage(error))
            }.bind(this))
      }
    },
    changeSorting(newSort) {
      this.sort = newSort
      this._initChannelGroupsList()
    },
    getActiveSort(column) {
      if (this.sort.column === column) {
        return this.sort.direction
      } else {
        return false
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingProviders/detail/ChannelGroupsList.vue